"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EOtpHandlerResultType = void 0;
/**
 * Типы эвентов отправляемых из каналов (otp-channel) в otp-handler
 */
var EOtpHandlerResultType;
(function (EOtpHandlerResultType) {
    /**
     * Успешное завершение
     *
     * При этом эвенте сессия закрывается на стороне канала
     */
    EOtpHandlerResultType["confirmed"] = "confirmed";
    /**
     * Обработка в процессе
     *
     * Используется в тех случаях когда надо отправить какие то данные в
     * otp-handler до остальных эвентов
     * (к примеру код сгенерирован и отправлен пользователю, но пока не дощёл)
     * Так же используется в тех случаях когда otp-channel получает либо генериует
     * какой либо id и надо его сразу использовать как internalChannelId
     */
    EOtpHandlerResultType["processing"] = "processing";
    /**
     * Завершилось с ошибкой
     *
     * При этом эвенте сессия закрывается на стороне канала
     */
    EOtpHandlerResultType["error"] = "error";
    /**
     * Отправка прошла успешно
     *
     * В тех случаях когда otp-channel отправляет что-то пользователю
     * к примеру код
     */
    EOtpHandlerResultType["successSend"] = "successSend";
    /**
     * Переданный код проверен успешно
     *
     * В тех случаях когда проверка кода проводилась на стороне otp-channel
     * либо otp-channel отправлял куда то для проверки
     */
    EOtpHandlerResultType["checkCodeSuccess"] = "checkCodeSuccess";
    /**
     * Переданнвый код не прощёл проверку
     *
     * В тех случаях когда проверка кода проводилась на стороне otp-channel
     * либо otp-channel отправлял куда то для проверки
     */
    EOtpHandlerResultType["checkCodeFailure"] = "checkCodeFailure";
    /**
     * Смена типа канала
     *
     * Происходит в каналах где в течении одной сессии
     * может произойти смена типа канала
     * (к примеру с бескодовго на канал с кодом в mts-mobileid)
     */
    EOtpHandlerResultType["channelCodeTypeChanged"] = "channelCodeTypeChanged";
    /**
     * Отравка кода
     *
     * В тех случаях когда код введённый пользователем приходит
     * в otp-channel, а проверка осуществляется в otp-handler
     */
    EOtpHandlerResultType["sendCode"] = "sendCode";
})(EOtpHandlerResultType || (exports.EOtpHandlerResultType = EOtpHandlerResultType = {}));
//# sourceMappingURL=OtpHandlerResultType.enum.js.map